import { render, staticRenderFns, recyclableRender, components } from "./storage-point.vue?vue&type=template&id=6bbaaa78&scoped=true&"
var renderjs
import script from "./storage-point.vue?vue&type=script&lang=js&"
export * from "./storage-point.vue?vue&type=script&lang=js&"
import style0 from "./storage-point.vue?vue&type=style&index=0&id=6bbaaa78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbaaa78",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/storage-point/storage-point.vue"
export default component.exports